module.exports = __webpack_public_path__ + "static/media/S1_00020.2a27055a.jpg";